
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "customDialog",
  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    operation: {
      type: String as PropType<string>,
      required: true,
    },
    processing: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
  emits: ["update:modelValue", "cancel", "operate"],
  methods: {
    modelValueChange(value: string) {
      this.$emit("update:modelValue", value);
    },
  },
});
